/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Min_Event_Gap_LabelInputs */



/**
* | output |
* | --- |
* | "Minimum Event Gap (sec)" |
*
* @param {Ad_Min_Event_Gap_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_min_event_gap_label = /** @type {((inputs?: Ad_Min_Event_Gap_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Min_Event_Gap_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Écart minimal entre événements (s)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Minimaler Ereignisabstand (Sek.)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Intervallo minimo tra eventi (sec)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимальный интервал между событиями (сек)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Separación mínima entre eventos (s)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最小事件间隔（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント間の最小間隔（秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट के बीच न्यूनतम अंतर (सेकंड)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Intervalo mínimo entre eventos (seg)")
	return /** @type {LocalizedString} */ ("Minimum Event Gap (sec)")
});